import { editTaskError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ task, nextTask }) =>
    present(
      repository
        .editTask(task, nextTask)
        .then((editedTask) =>
          repository.getTask(editedTask.uuid).then((savedTask) => ({
            ...savedTask,
            ...editedTask,
            allocations:
              task.status.uuid !== nextTask.status.uuid &&
              task.status.percentComplete === 100 &&
              typeof nextTask.status.percentComplete !== "undefined"
                ? savedTask.allocations.map((allocation) => ({
                    ...allocation,
                    percentComplete: nextTask.status.percentComplete as number,
                  }))
                : savedTask.allocations,
          })),
        )
        .catch((e) =>
          Promise.reject({
            error: { ...editTaskError, ...e },
            task,
            nextTask,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
